import { clsx } from 'clsx'
import { type FC } from 'react'

import { useGetExperimentForTenant } from '../../../../experiments/hooks'
import { EXPERIMENT_HEADER_STICKY_TOGGLE } from '../../../../experiments/model/EXPERIMENT_NAME_PER_TENANT'
import {
  experimentAccessorIsEnabledAndDefault,
  experimentAccessorNonDefault,
} from '../../../../experiments/model/experimentAccessor'
import { useHeaderDataContext } from '../../headerConfigContext'
import { headerCmsBlockMenuAccessorGetNavigationMenuData } from '../../model/headerCmsBlockMenuAccessor'

import { HeaderNavigation } from './HeaderNavigation'

export const HeaderBottomSection: FC = () => {
  const { cmsMenu } = useHeaderDataContext()
  const headerStickyToggleExperiment = useGetExperimentForTenant(
    EXPERIMENT_HEADER_STICKY_TOGGLE,
  )
  const shouldMiddleSectionPositiobBeRelative =
    !headerStickyToggleExperiment.isEnabled ||
    experimentAccessorIsEnabledAndDefault(headerStickyToggleExperiment)

  return (
    <div
      className={clsx(
        'z-20 hidden bg-light-primary-low tablet:flex',
        shouldMiddleSectionPositiobBeRelative && 'relative',
        experimentAccessorNonDefault(headerStickyToggleExperiment) && 'static',
      )}
    >
      <div className="mt-3 w-full bg-light-brand-high">
        <HeaderNavigation
          menuItems={headerCmsBlockMenuAccessorGetNavigationMenuData(cmsMenu)}
        />
      </div>
    </div>
  )
}
